<template>
  <section class="d-grid gap-4">
    <header>
      <h2 class="h4 mb-1">Reportes operativos</h2>
      <p class="text-muted mb-0">
        Ventas, caja, productos, cuentas por cobrar y compras — con export a CSV.
      </p>
    </header>

    <div class="row g-3">
      <div v-for="card in cards" :key="card.to.name" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">{{ card.title }}</h3>
            <p class="text-muted small mb-3">{{ card.description }}</p>
            <router-link class="btn btn-dark btn-sm" :to="card.to">Abrir</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const cards = [
  {
    // Primero: es la pregunta que se hace todos los dias («¿cuanto entro
    // hoy?») y la unica que ve los cobros de suscripcion.
    title: 'Ingresos por período',
    description: 'Cobros de suscripción, ventas de productos e ingresos varios, en una sola tabla.',
    to: { name: 'ReportesIngresos' },
  },
  {
    title: 'Ventas por período',
    description: 'Lo fiscal de las ventas: comprobante, IVA y método de pago.',
    to: { name: 'ReportesVentas' },
  },
  {
    title: 'Cierres de caja',
    description: 'Historial de aperturas cerradas: declarado vs esperado y diferencias.',
    to: { name: 'ReportesCierresCaja' },
  },
  {
    title: 'Productos vendidos',
    description: 'Más y menos vendidos por período y categoría.',
    to: { name: 'ReportesProductosVendidos' },
  },
  {
    title: 'Cuentas por cobrar',
    description: 'Lo que deben las cuotas, por antigüedad.',
    to: { name: 'ReportesCuentasPorCobrar' },
  },
  {
    title: 'Cobranza del período',
    description: 'De lo que había que cobrar cada mes, cuánto entró.',
    to: { name: 'ReportesCobranzaPeriodo' },
  },
  {
    title: 'Deuda por responsable',
    description: 'A quién hay que llamar, con su teléfono y su saldo.',
    to: { name: 'ReportesDeudaPorResponsable' },
  },
  {
    title: 'Utilidad',
    description: 'Ingresos menos egresos del período, con su composición.',
    to: { name: 'ReportesUtilidad' },
  },
  {
    title: 'Compras por proveedor',
    description: 'Facturas de compra por proveedor y período.',
    to: { name: 'ReportesComprasProveedor' },
  },
  {
    title: 'Créditos de clientes',
    description: 'Saldo del crédito de almacén. No es la deuda de las cuotas.',
    to: { name: 'ReportesCreditosClientes' },
  },
]
</script>
